<mat-form-field class="fd-input__container" color="accent" [formGroup]="parentForm">
  <mat-label>{{field?.label}}</mat-label>
  <input matInput [formControlName]="field?.controlName" autocomplete="off" class="fd-input__field"
    [mask]="field?.mask ? field.mask : null"
    [validation]="false"
    [dropSpecialCharacters]="false"
    [id]="field?.controlName" [required]="required || null" aria-label="Area code" [type]="field?.type || 'text'"
    autocomplete="off" [attr.disabled]="field?.disabled || null" tabindex="0" (blur)="handleBlur($event)"
    (input)="handleChange($event)" />
  <mat-icon matSuffix class="fd-input__icon-container" *ngIf="hasIcon" [innerHTML]="field?.iconHTML">
  </mat-icon>
  <fa-icon *ngIf="field?.tooltipMessage" matTooltipClass="fd-input__tooltip-dialog" class="fd-input__tooltip-icon"
    icon="info-circle" size="1x" mat-button [matTooltip]="field?.tooltipMessage"
    (mouseenter)="$event.stopImmediatePropagation()" (mouseleave)="$event.stopImmediatePropagation()"
    #tooltip="matTooltip" (click)="showTooltipAndStopPropagation($event)">
  </fa-icon>
  <mat-hint class="fd-input__hint">{{ field?.hint }}</mat-hint>
  @if (hasError) {
    <mat-error *ngFor="let errorMessage of errorMessages">{{errorMessage}}</mat-error>
  }
</mat-form-field>
